<template>
  <svg :class="classes" :style="getStyle" aria-hidden="true">
    <use :xlink:href="symbolId" />
  </svg>
</template>
<script lang="ts">
  import type { CSSProperties } from 'vue';
  import { defineComponent, computed, useAttrs, unref } from 'vue';
  import { createNamespace } from '@mcex/utils';

  export default defineComponent({
    name: 'SvgIcon',
    props: {
      prefix: {
        type: String,
        default: 'icon',
      },
      name: {
        type: String,
        required: true,
      },
      size: {
        type: [Number, String],
        default: 16,
      },
      spin: {
        type: Boolean,
        default: false,
      },
    },
    setup(props) {
      const { bem } = createNamespace('svg-icon');
      const attrs = useAttrs();

      const symbolId = computed(() => {
        if (props.prefix === 'ali') {
          return `#${props.name}`;
        }
        return `#${props.prefix}-${props.name}`;
      });

      const classes = computed(() => {
        const cls = [bem(), unref(attrs).class];
        props.spin && cls.push(bem('spin'));
        return cls;
      });
      const getStyle = computed((): CSSProperties => {
        const { size } = props;
        let s = `${size}`;
        s = `${s.replace('px', '')}px`;
        return {
          width: s,
          height: s,
        };
      });
      return { symbolId, classes, getStyle };
    },
  });
</script>
<style scoped>
  .svg-icon {
    display: inline-block;
    overflow: hidden;
    vertical-align: -0.15em;
    fill: currentColor;
  }

  .svg-icon__spin {
    animation: loadingCircle 1s infinite linear;
  }
</style>
